export default "__VITE_ASSET__e1r$9JCI__"